module.exports = __webpack_public_path__ + "img/5425003947384.499b6b1a.png";